import React, { Component } from "react";
import { RadioButton } from "material-ui/RadioButton";
import TextField from "material-ui/TextField";
import Checkbox from "material-ui/Checkbox";
import RaisedButton from "material-ui/RaisedButton";
import { Typeahead } from "react-bootstrap-typeahead";
import remove from "lodash/remove";
import filter from "lodash/filter";
import isEmpty from "lodash/isEmpty";
import Tooltip from "rc-tooltip";
import uniq from "lodash/uniq";
import map from "lodash/map";
import groupBy from "lodash/groupBy";
import difference from "lodash/difference";
// primary color for material-ui
import { primaryColor } from "../../../../utils/utility";
// progress
import CircularProgress from "material-ui/CircularProgress";
import "./addLoction.css";
import { SSL_OP_DONT_INSERT_EMPTY_FRAGMENTS } from "constants";

//performance

const styles = {
  raidoIcon: {
    color: "black",
  },
  divider: {
    borderBottom: "1px solid black",
    marginBottom: "6px",
  },
  iconStyle: {
    fill: primaryColor(),
  },
  textareaUnderlineStyle: {
    borderBottom: "1px solid red",
  },
  rootElementStyle: {
    height: "400px",
  },
  btnStyle: {
    background: primaryColor(),
    color: "#FFF",
  },
  searchStyle: {
    borderColor: primaryColor(),
  },
};
class AddLocation extends Component {
  constructor(props) {
    super(props);
    this.flag = true; // controll state bg for first time
    this.state = {
      checkedState:
        !isEmpty(props.selected_state) || !isEmpty(props.selected_city),
      checkedZip: !isEmpty(props.zipcode),
      checkedDMA: !isEmpty(props.selected_dma),
      checkedCounty: !isEmpty(props.selected_county),
      stateActiveIndex: "",
      ifShowRightPanel: "", // show right panel when middle panel was selected
      beSearchedCityId: "",
      selectedStateLabel: "", // for searchbar placeholder
      stateCounties: [],
      stateDMAs: [],
      selectedStateId: "",
      ifallCitiesSelected: false,
      ifZipcodeValid: true,
      zipcode: "",
      checkUserSelectedState: [],
      stateAndCityTipStatus: false,
      inValidZips: [],
      selectedStateCounties: [],
    };
  }
  componentDidUpdate(prevProps) {
    if (this.state.checkedCounty && this.props.selected_county.length > 0) {
    }
  }
  componentWillReceiveProps(nextProps) {
    // when selected_city length > 0 implement filter function
    if (
      nextProps.all_state_cities.length > 0 &&
      (nextProps.selected_city.length > 0 ||
        nextProps.selected_state.length > 0)
    ) {
      this.citySelectedStateChecked(nextProps);
    }
  }

  componentDidMount() {
    // if (this.props.selected_city.length === 0) {
    //   this.flag = false
    // }
    setTimeout(
      function() {
        if (this.state.checkedState)
          this.refs.stateUI.style.borderBottom = "1px solid black";
        else if (this.state.checkedCounty)
          this.refs.countyUI.style.borderBottom = "1px solid black";
        else if (this.state.checkedDMA)
          this.refs.dmaUI.style.borderBottom = "1px solid black";
      }.bind(this),
      900,
    );
    if (
      this.props.selected_city.length > 0 ||
      this.props.selected_state.length > 0
    ) {
      this.setState({
        checkedState: true,
      });
    }
    if (this.props.zipcode.length > 0) {
      this.setState({
        checkedZip: true,
      });
    }
    let arr = [];
    // filter the selected state for segment list
    const all_state_cities = this.props.all_state_cities;
    if (all_state_cities && all_state_cities instanceof Array) {
      all_state_cities.forEach(item => {
        this.props.selected_city.forEach(city => {
          item.cities.forEach(index => {
            if (index.id === city.id) {
              arr.push(item.state);
            }
          });
        });
      });
    }

    let state_index = []; // for state select
    let state_city_index = []; // for select city
    if (this.props.allStates) {
      this.props.allstates.forEach((item, index) => {
        this.props.selected_state.forEach(list => {
          if (list.id === item.id) {
            state_index.push(index);
          }
        });
        arr.forEach(list => {
          if (list.id === item.id) {
            state_city_index.push(index);
          }
        });
      });
    }

    if (
      state_index[0] > state_city_index[0] ||
      (typeof state_index[0] === "undefined" &&
        typeof state_city_index[0] === "number")
    ) {
      // state has city in the front and call click function
      this.handleShowStateCities(
        {
          target: {
            value: "text",
          },
        },
        arr[0].id,
        arr[0].label,
        state_city_index[0],
        arr,
      );
    } else if (
      state_index[0] < state_city_index[0] ||
      (typeof state_index[0] === "number" &&
        typeof state_city_index[0] === "undefined")
    ) {
      // state select in the front and call click function
      this.handleShowStateCities(
        {
          target: {
            value: "text",
          },
        },
        this.props.selected_state[0].id,
        this.props.selected_state[0].label,
        state_index[0],
      );
    }
  }

  citySelectedStateChecked({ all_state_cities, selected_city }) {
    let arr = [];
    // filter the selected state for segment list
    all_state_cities.forEach(item => {
      selected_city.forEach(city => {
        item.cities.forEach(index => {
          if (index.id === city.id) {
            arr.push(item.state.id);
          }
        });
      });
    });
    this.setState(
      {
        checkUserSelectedState: arr,
      },
      () => {
        // position state list
        let state_index = []; // for state select
        let state_city_index = []; // for select city
        this.props.allstates.forEach((item, index) => {
          this.props.selected_state.forEach(list => {
            if (list.id === item.id) {
              state_index.push(index);
            }
          });
          this.state.checkUserSelectedState.forEach(list => {
            if (list === item.id) {
              state_city_index.push(index);
            }
          });
        });
        let liHeight = this.refs.stateList.clientHeight;

        if (
          state_index[0] > state_city_index[0] ||
          (typeof state_index[0] === "undefined" &&
            typeof state_city_index[0] === "number")
        ) {
          // when city selected
          if (this.flag) {
            this.setState({
              stateActiveIndex: state_city_index[0], // add background for state label when city has been selected
              ifShowRightPanel: true,
            });
            if (this.state.checkedState) {
              this.refs.stateUI.scrollTop = liHeight * state_city_index[0];
            } else if (this.state.checkedCounty) {
              this.refs.countyUI.scrollTop = liHeight * state_city_index[0];
            } else if (this.state.checkedDMA) {
              this.refs.dmaUI.scrollTop = liHeight * state_city_index[0];
            }
            this.flag = false;
          }
        } else if (
          state_index[0] < state_city_index[0] ||
          (typeof state_index[0] === "number" &&
            typeof state_city_index[0] === "undefined")
        ) {
          // when state selected
          if (this.flag) {
            this.setState({
              stateActiveIndex: "",
              ifShowRightPanel: false,
            });
            if (this.state.checkedState) {
              this.refs.stateUI.scrollTop = liHeight * state_index[0];
            } else if (this.state.checkedCounty) {
              this.refs.countyUI.scrollTop = liHeight * state_index[0];
            } else if (this.state.checkedDMA) {
              this.refs.dmaUI.scrollTop = liHeight * state_index[0];
            }
            this.flag = false;
          }
        }
      },
    );
  }

  handleRadio(e) {
    e.stopPropagation();
    switch (e.target.value) {
      case "state":
        this.setState({
          checkedState: true,
          checkedZip: false,
          checkedCounty: false,
          checkedDMA: false,
          stateAndCityTipStatus: true,
          selectedStateLabel: "",
          selectedStateId: "",
        });
        this.props.clearAllZipCode();
        this.props.clearMapPlotted();
        this.props.clearAllDMA();
        this.props.clearAllCounty();
        break;
      case "zip":
        this.setState({
          checkedZip: true,
          checkedState: false,
          checkedCounty: false,
          checkedDMA: false,
          ifShowRightPanel: "",
          stateAndCityTipStatus: false,
          selectedStateLabel: "",
          selectedStateId: "",
        });
        this.props.clearMapPlotted();
        this.props.clearAllSelectedState();
        this.props.clearAllSelectedCity();
        this.props.clearAllZipCode();
        this.props.clearAllDMA();
        this.props.clearAllCounty();
        break;
      case "county":
        this.setState({
          checkedState: false,
          checkedZip: false,
          checkedCounty: true,
          checkedDMA: false,
          stateAndCityTipStatus: true,
          selectedStateLabel: "",
          selectedStateId: "",
        });
        this.props.clearAllZipCode();
        this.props.clearMapPlotted();
        this.props.clearAllSelectedState();
        this.props.clearAllSelectedCity();
        this.props.clearAllDMA();
        break;
      case "dma":
        this.setState({
          checkedState: false,
          checkedZip: false,
          checkedCounty: false,
          checkedDMA: true,
          stateAndCityTipStatus: true,
          selectedStateLabel: "",
          selectedStateId: "",
        });
        this.props.clearAllZipCode();
        this.props.clearMapPlotted();
        this.props.clearAllSelectedState();
        this.props.clearAllSelectedCity();
        this.props.clearAllCounty();
        break;
      default:
        return;
    }
  }
  handleStateSelected(e, isInputChecked, stateObj) {
    if (this.state.checkedState) {
      this.props.selectState(stateObj, isInputChecked);
      if (isInputChecked) {
        let activeAllcities = this.props.all_state_cities.find(
          item => item.state.id === stateObj.id,
        ) || { cities: [] };
        activeAllcities.cities.forEach(item => {
          remove(this.props.selected_city, n => n.id === item.id);
        });
        let rc = uniq(this.state.checkUserSelectedState).filter(
          item => item !== stateObj.id,
        );
        this.setState({
          checkUserSelectedState: rc,
          stateAndCityTipStatus: false, // author chargo 2015-8-16 close tips when click state's checkbox
        });
      }
      this.setState({
        ifShowRightPanel: false,
        stateActiveIndex: "",
      });
    } else if (this.state.checkedCounty) {
      const stateVal = stateObj.value;
      map(this.props.counties, c => {
        if (c.label.indexOf(stateVal) > 0) {
          this.props.selectCounty(c, stateObj.label, isInputChecked);
        }
      });
      setTimeout(
        function() {
          this.props.reCalculateTotal();
        }.bind(this),
        200,
      );
    } else if (this.state.checkedDMA) {
      const stateVal = stateObj.value;
      map(this.props.dmas, c => {
        if (c.label.indexOf(stateVal) > 0) {
          this.props.selectDMA(c, stateObj.label, isInputChecked);
        }
      });
      setTimeout(
        function() {
          this.props.reCalculateTotal();
        }.bind(this),
        200,
      );
    }
  }
  handleShowStateItems(
    e,
    stateId,
    stateLabel,
    index,
    mockCheckUserSelectedState = [],
  ) {
    // when click state text area
    if (e.target.type !== "checkbox") {
      this.refs.cityUl.scrollTop = 0;
      this.setState({
        ifShowRightPanel: true,
        stateActiveIndex: index,
        selectedStateLabel: stateLabel,
        selectedStateId: stateId,
        stateAndCityTipStatus: false, // author charg 2015-8-16 close tips, when click state's text
      });
      // this.props.loading();
      if (this.state.checkedState) {
        this.props.getCities(stateId);
        if (this.props.selected_state.some(obj => obj.id === stateId)) {
          this.setState({
            ifallCitiesSelected: true,
          });
        } else {
          this.setState({
            ifallCitiesSelected: false,
          });
        }
        if (
          (this.state.checkUserSelectedState.some(item => item === stateId) ||
            mockCheckUserSelectedState.some(item => item.id === stateId)) &&
          !this.props.ifLoading
        ) {
          let activeAllcities = this.props.all_state_cities.find(
            item => item.state.id === stateId,
          );
          let selected_city_index = [];
          let activeId = [];
          activeAllcities.cities.forEach((city, index) => {
            if (this.props.selected_city.some(item => item.id === city.id)) {
              activeId.push(city.id);
              selected_city_index.push(index);
            }
          });
          window.setTimeout(() => {
            let liHeight = this.refs.cityList.clientHeight;
            this.refs.cityUl.scrollTop = selected_city_index[0] * liHeight;
            this.setState({
              beSearchedCityId: activeId[0],
            });
          }, localStorage.getItem("spareTime"));
        }
      }
      if (this.state.checkedCounty) {
        const subItems = filter(this.props.counties, c => {
          return c.label.indexOf(stateLabel) >= 0;
        });
        this.setState({
          stateCounties: subItems,
        });
      }
      if (this.state.checkedDMA) {
        const subItems = filter(this.props.dmas, d => {
          return d.label.indexOf(stateLabel) >= 0 || d.value === "999";
        });
        this.setState({
          stateDMAs: subItems,
        });
      }
    }
    // when click checkbox
    if (e.target.type === "checkbox") {
      this.setState({
        checkboxStateIndex: index,
      });
    }
  }
  handleCitySelected(e, isInputChecked, index, cityObj) {
    this.setState({
      checkboxCityIndex: index,
      beSearchedCityId: "", // cancel active class name for city list
    });
    let arr = [];
    if (this.state.checkedState) {
      if (!isInputChecked) {
        if (this.state.checkedState) {
          this.props.all_state_cities.forEach(item => {
            this.props.selected_city.forEach(city => {
              item.cities.forEach(index => {
                if (index.id === city.id) {
                  arr.filter(n => n !== item.state.id);
                }
              });
            });
          });
        }

        this.setState({
          checkUserSelectedState: arr,
        });
      }

      this.props.selectCity(
        cityObj,
        this.state.selectedStateLabel,
        isInputChecked,
      );
    }
    if (this.state.checkedCounty) {
      this.props.selectCounty(
        cityObj,
        this.state.selectedStateLabel,
        isInputChecked,
      );
      setTimeout(
        function() {
          this.props.reCalculateTotal();
        }.bind(this),
        50,
      );
    }
    if (this.state.checkedDMA) {
      this.props.selectDMA(
        cityObj,
        this.state.selectedStateLabel,
        isInputChecked,
      );
      setTimeout(
        function() {
          this.props.reCalculateTotal();
        }.bind(this),
        50,
      );
    }
  }
  handleCityChange(selectedItem, cities) {
    // compute search result position
    let liHeight = this.refs.cityList.clientHeight;
    if (selectedItem.length > 0) {
      cities.forEach((city, index) => {
        if (city.id === selectedItem[0].id) {
          // compute scrollTop
          this.refs.cityUl.scrollTop = index * liHeight;
          this.setState({
            beSearchedCityId: selectedItem[0].id,
          });
        }
      });
    }
  }
  showTypeahead(items) {
    const textType = this.state.checkedState
      ? "city"
      : this.state.checkedCounty
      ? "county"
      : this.state.checkedDMA
      ? "DMA"
      : "";

    return [
      <Typeahead
        key="city_search_box"
        labelKey="label"
        multiple={false}
        options={items}
        placeholder={`Find ${textType} in ${this.state.selectedStateLabel}`}
        onChange={selectedItem => this.handleCityChange(selectedItem, items)}
      />,
      <div
        key="city_search_text"
        className="form-control-feedback"
        style={{ width: "54px" }}
      >
        <span className="text-uppercase no-padding no-margin">search</span>
      </div>,
    ];
  }
  handleZipCode(e, newValue) {
    const matchArrs = newValue.match(/\b\d{5}\b/g);
    const arrs = newValue.split(",");
    const diff = difference(arrs, matchArrs);
    if (isEmpty(diff)) {
      this.setState({
        ifZipcodeValid: false,
        zipcode: newValue,
        inValidZips: [],
      });
    } else {
      this.setState({
        ifZipcodeValid: true,
        inValidZips: diff,
      });
    }
    /*
    if (/((^\d{5}|^\d{5}-\d{5})(,(\d{5}|\d{5}-\d{5}))*$)/.test(newValue)) {
      this.setState({
        ifZipcodeValid: false,
        zipcode: newValue,
      });
    } else {
      this.setState({
        ifZipcodeValid: true,
      });
    }*/
  }
  handleApplyClick(e) {
    if (!this.state.ifZipcodeValid) {
      const zipcodes = uniq(this.state.zipcode.split(","));
      this.props.addZipCode(zipcodes.join(","));
      this.setState({
        checkedZip: true,
        checkedState: false,
        checkedDMA: false,
        checkedCounty: false,
        zipcode: "",
        ifZipcodeValid: true,
      });
      document.getElementById(this.refs.textarea.uniqueId).value = "";
    }
  }

  renderStates(allstates, selected_state) {
    if (typeof allstates === "undefined") return "";
    const result = [];
    const countyStates = groupBy(this.props.selected_county, c => {
      return c.label.split(",")[1].trim();
    });
    const allCountyStates = groupBy(this.props.counties, c => {
      return c.label.split(",")[1].trim();
    });
    const dmaStates = groupBy(this.props.selected_dma, d => {
      return d.label.indexOf(",") >= 0 && d.label.split(",")[1].trim();
    });
    const allDMAStates = groupBy(this.props.dmas, d => {
      if (d.label.indexOf(",") >= 0) return d.label.split(",")[1].trim();
    });

    allstates.map((item, index) => {
      let showCheckIcon = false;
      let isStateChecked = false;

      if (this.state.checkedState) {
        showCheckIcon = this.state.checkUserSelectedState.some(
          stateId => stateId === item.id,
        );
        isStateChecked = selected_state.some(state => state.id === item.id);
      }
      if (this.state.checkedCounty) {
        showCheckIcon = Object.keys(countyStates).indexOf(item.value) >= 0;
        isStateChecked =
          countyStates[item.value] &&
          allCountyStates[item.value] &&
          countyStates[item.value].length ===
            allCountyStates[item.value].length;
      }
      if (this.state.checkedDMA) {
        showCheckIcon = this.props.selected_dma.some(
          d => d.label.indexOf(item.value) >= 0,
        );
        isStateChecked =
          dmaStates[item.value] &&
          allDMAStates[item.value] &&
          dmaStates[item.value].length === allDMAStates[item.value].length;
      }
      result.push(
        <li
          key={item.awId}
          ref="stateList"
          onClick={e => {
            this.handleShowStateItems(e, item.id, item.value, index);
          }}
          className={this.state.stateActiveIndex === index ? "active" : ""}
        >
          <Checkbox
            onCheck={(e, isInputChecked) =>
              this.handleStateSelected(e, isInputChecked, item)
            }
            label={item.label}
            iconStyle={styles.iconStyle}
            inputStyle={{ width: "10%" }}
            labelStyle={{ fontSize: "15.6px" }}
            checked={isStateChecked}
          />
          <span
            className="text-teal-400"
            style={{
              position: "absolute",
              top: "0",
              right: "4em",
              display: showCheckIcon ? "inline" : "none",
            }}
          >
            <i className="icon-checkmark4 " />
          </span>
          <small
            style={{
              display:
                this.state.stateActiveIndex === index ? "none" : "inline",
            }}
          >
            >
          </small>
        </li>,
      );
    });
    return result;
  }
  render() {
    const {
      allstates,
      selected_city,
      allcities,
      selected_state,
      selected_county,
      selected_dma,
    } = this.props;
    let subItems = this.state.checkedState
      ? allcities
      : this.state.checkedCounty
      ? this.state.stateCounties
      : this.state.checkedDMA
      ? this.state.stateDMAs
      : undefined;
    const selected_subitems = this.state.checkedState
      ? selected_city
      : this.state.checkedCounty
      ? selected_county
      : this.state.checkedDMA
      ? selected_dma
      : undefined;
    const geographicText = (
      <section>
        <div>Selectiong Geographic Attributes:</div>
        <div>US States and Cities</div>
        <div>When selecting geographic attributes,</div>
        <div>remember:</div>
        <br />
        <span>You can build your segment by selecting</span> <br />
        <span>either US States/Cities or US Zip Codes</span> <br />
        <br />
        <span>If you make one radio button selection</span> <br />
        <span>and select attributes for that category.any</span> <br />
        <span>selections made will be deleted if you then</span> <br />
        <span>select the other radio button</span> <br />
        <br />
        <span>To select an entire state,select that state's</span> <br />
        <span>checkbox</span> <br />
        <span>To display a state's cities,select that state's</span> <br />
        <span>row.</span>
      </section>
    );
    return (
      <div className="add-location">
        <div className="row">
          <div
            className={
              this.state.checkedZip
                ? "col-xs-12 col-md-12 col-sm-10 col-lg-12"
                : "col-xs-6 col-md-6 col-sm-6 col-lg-6 states"
            }
          >
            <div
              className="radio-button-group"
              onClick={e => this.handleRadio(e)}
            >
              <Tooltip
                placement="right"
                overlay={geographicText}
                arrowContent={<div className="rc-tooltip-arrow-inner" />}
              >
                <div
                  style={{
                    display: "inline-block",
                    color: "#1E88E5",
                    cursor: "pointer",
                    marginBottom: "1em",
                  }}
                >
                  Tips
                </div>
              </Tooltip>
              {/*author chargo 2017-8-15*/}
              <section
                className="city-state-radio-tips"
                style={{
                  display: this.state.stateAndCityTipStatus ? "block" : "none",
                }}
              >
                <p>
                  To select an entire state. <br />
                </p>
                <p className="last-p">
                  select that state's checkbox. <br />
                </p>
                <p>
                  To display a state's CITIES,COUNTIES or DMA. <br />
                </p>
                <p>
                  select that state's row. <br />
                </p>
              </section>
              {/*the end*/}
              <RadioButton
                value="state"
                label="US CITY/STATE"
                inputStyle={styles.raidoIcon}
                checked={this.state.checkedState}
                iconStyle={styles.iconStyle}
                labelStyle={{ fontSize: "14px" }}
              />
              <ul
                className="state-wrapper"
                ref="stateUI"
                style={{
                  height: this.state.checkedState ? "384px" : "0",
                  opacity: this.state.checkedState ? "1" : "0",
                }}
              >
                {this.renderStates(allstates, selected_state)}
              </ul>

              <RadioButton
                value="county"
                label="COUNTY"
                checked={this.state.checkedCounty}
                iconStyle={styles.iconStyle}
                labelStyle={{ fontSize: "14px" }}
              />
              <ul
                className="state-wrapper"
                ref="countyUI"
                style={{
                  height: this.state.checkedCounty ? "384px" : "0",
                  opacity: this.state.checkedCounty ? "1" : "0",
                }}
              >
                {this.renderStates(allstates, selected_state)}
              </ul>
              <RadioButton
                value="dma"
                label="DMA"
                checked={this.state.checkedDMA}
                iconStyle={styles.iconStyle}
                labelStyle={{ fontSize: "14px" }}
              />
              <ul
                className="state-wrapper"
                ref="dmaUI"
                style={{
                  height: this.state.checkedDMA ? "384px" : "0",
                  opacity: this.state.checkedDMA ? "1" : "0",
                }}
              >
                {this.renderStates(allstates, selected_state)}
              </ul>
              <RadioButton
                value="zip"
                label="ZIP CODE"
                checked={this.state.checkedZip}
                iconStyle={styles.iconStyle}
                labelStyle={{ fontSize: "14px" }}
              />
              <div
                className="show-zipcode clearfix"
                style={{
                  width: "95%",
                  display: this.props.zipcode.length > 0 ? "block" : "none",
                }}
              >
                {this.props.zipcode.map((item, index) => (
                  <span
                    className="text-muted text-light ml-10"
                    style={{ float: "left" }}
                    key={index}
                  >
                    <small>{item.zipcode}</small>
                  </span>
                ))}

                <span className="text-teal-400 ml-10" style={{ float: "left" }}>
                  <i className="icon-checkmark4 text-size-md " />
                </span>
              </div>
              <div
                className="zip-code-wrapper"
                style={{ height: this.state.checkedZip ? "360px" : "0" }}
              >
                <div className="text-area">
                  <TextField
                    fullWidth={true}
                    multiLine={true}
                    rows={1}
                    rowsMax={11}
                    underlineShow={false}
                    hintText="Enter Zip Code(s) or Zip Code Range(s)"
                    onChange={(e, newValue) => this.handleZipCode(e, newValue)}
                    errorText={this.state.errorText}
                    ref="textarea"
                  />
                </div>
                <p className="tips">
                  If entering multiple zip codes or zip code ranges, separate
                  each with a comma
                </p>
                <div>
                  <RaisedButton
                    label="Apply"
                    buttonStyle={styles.btnStyle}
                    labelColor="#FFF"
                    disabled={this.state.ifZipcodeValid}
                    onTouchTap={e => this.handleApplyClick(e)}
                  />
                  <span className="ml-10" style={{ color: "#FF0000" }}>
                    {!isEmpty(this.state.inValidZips) &&
                      "Some invalid zipcodes: " +
                        this.state.inValidZips.join(",")}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div
            className="col-xs-6 col-md-6 col-sm-6 col-lg-6 search-box"
            style={{ display: this.state.ifShowRightPanel ? "block" : "none" }}
          >
            <div className="search-bar clearfix">
              <div
                className="col-xs-12 col-md-12 col-sm-12 col-lg-12"
                style={{ padding: 0, marginTop: "-5px" }}
              >
                <span className="input-group" style={{ width: "100%" }}>
                  {typeof subItems !== "undefined" &&
                    this.showTypeahead(subItems)}
                </span>
              </div>
            </div>
            <div className="city-selection-scrollable">
              {this.state.checkedDMA && (
                <div
                  style={{
                    height: "40px",
                    paddingTop: "10px",
                    background: "rgb(232, 232, 232)",
                    marginLeft: "40px",
                    marginBottom: "20px",
                  }}
                >
                  <span style={{ marginLeft: "10px" }}>
                    <strong>Code</strong>
                  </span>
                  <span style={{ marginLeft: "60px" }}>
                    <strong>DMA</strong>
                  </span>
                </div>
              )}
              <ul className="city-selection-parent" ref="cityUl">
                {typeof subItems !== "undefined" &&
                  subItems.map((item, index) => {
                    if (index === 0) {
                      this.startRenderTime = new Date().getTime();
                    }

                    if (index === allcities.length - 1) {
                      this.endRenderTime = new Date().getTime();
                    }
                    return (
                      <li
                        key={item.id}
                        ref="cityList"
                        className={
                          item.id === this.state.beSearchedCityId
                            ? "active"
                            : ""
                        }
                      >
                        <Checkbox
                          onCheck={(e, isInputChecked) =>
                            this.handleCitySelected(
                              e,
                              isInputChecked,
                              index,
                              item,
                            )
                          }
                          label={
                            this.state.checkedDMA
                              ? [
                                  <span
                                    style={{
                                      marginLeft: "10px",
                                      marginRight: "30px",
                                    }}
                                  >
                                    {item.value}
                                  </span>,
                                  <span style={{ whiteSpace: "nowrap" }}>
                                    {item.label}
                                  </span>,
                                ]
                              : item.label
                          }
                          iconStyle={styles.iconStyle}
                          // defaultChecked={(typeof selected_city !== 'undefined' && selected_city.some((value) => value === city.id)) || this.state.ifallCitiesSelected}
                          labelStyle={{ fontSize: "15.6px" }}
                          checked={
                            (typeof selected_subitems !== "undefined" &&
                              selected_subitems.some(
                                value => value.id === item.id,
                              )) ||
                            this.state.ifallCitiesSelected
                          }
                        />
                      </li>
                    );
                  })}
              </ul>
              {(typeof allcities === "undefined" || this.props.ifLoading) && (
                <div className="progress-city">
                  <CircularProgress style={{ top: "40%" }} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AddLocation.defaultProps = {
  selected_city: [],
  selected_state: [],
  all_state_cities: [],
  allcities: [],
  ifLoading: true,
};
export default AddLocation;



// WEBPACK FOOTER //
// ./src/components/Segment/Creation/Geography/AddLocation.jsx